<script lang="ts">

    import { redirectTo } from "../scripts/router1";
    import { idPagePartenaire } from "../scripts/router2";
    import { storeEcosystemId, EcosystemInterface } from "../scripts/ecosystem";

    export let props: EcosystemInterface;

    /**
    * selectEcosystem
    */
    function selectPartner() {
        storeEcosystemId.set(props.id);
        redirectTo(idPagePartenaire, "?id="+props.id);
    }


</script>

<style lang="scss">

	.tilepartner {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 30px 0 30px 0;
        &__link {
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        &__img {
            padding: 15px 15px 15px 15px;
            width: 100%;
            height: auto;
            border: 1px solid $color_orange;
            border-radius: 10px;
        }
        &__imghome {
            width: 100%;
            height: auto;
        }
	}

    @include large {
        .tilepartner {
            width: 30%;
            &__img {
                width: 50%;
                height: auto;
                cursor: pointer;
                transition: all 0.5s;
                &:hover {
                    transform: scale(0.8);
                }
            }
            &__imghome {
                width: 100%;
                height: auto;
                cursor: pointer;
                transition: all 0.5s;
                &:hover {
                    transform: scale(0.8);
                }
            }
        }
    }

</style>

{#if (props.published)}
<div class="tilepartner" on:click={() => selectPartner()} on:keydown={() => selectPartner()}>
    {#if (props.logo_home != undefined && props.logo_home != null && props.logo_home != "")}
    <img class="tilepartner__imghome" alt={props.name} src="../assets/images/ecosystem/{props.id}_home_{props.logo_home}">
    {:else}
    <img class="tilepartner__img" alt={props.name} src="../assets/images/ecosystem/{props.id}_{props.logo}">
    {/if}
</div>
{:else}
<div class="tilepartner">
    <a class="tilepartner__link" href="{props.website}" target="_blank">
        {#if (props.logo_home != undefined && props.logo_home != null && props.logo_home != "")}
        <img class="tilepartner__imghome" alt={props.name} src="../assets/images/ecosystem/{props.id}_home_{props.logo_home}">
        {:else}
        <img class="tilepartner__img" alt={props.name} src="../assets/images/ecosystem/{props.id}_{props.logo}">
        {/if}
    </a>
</div>
{/if}